import React, { useState, useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { USDollarCurrencyInputAdornment } from './USDollarCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';

const ExpenseReimbursedAmount = ({
    index,
    expense,
    isPendingSubmission,
    isPosted,
    isViewOnly,
    isInvoiceReviewLocked = false,
    enableEditByCorrection,
    size,
}) => {
    const { control, errors } = useFormContext();
    const [required, setRequired] = useState({ required: false });
    const notRequiredStatuses = [
        ExpenseStatusValuesEnum.NeedMoreInformation,
        ExpenseStatusValuesEnum.OnHoldReimbursement,
        ExpenseStatusValuesEnum.ReviewOnHold,
        ExpenseStatusValuesEnum.ReturnedByAccounting,
        ExpenseStatusValuesEnum.NonReimbursable,
        ExpenseStatusValuesEnum.Abandoned,
    ];
    useEffect(() => {
        setRequired({ required: !notRequiredStatuses.includes(expense?.status) });
    }, [expense?.status]);

    const isDisabled =
        isViewOnly ||
        isInvoiceReviewLocked ||
        (isPendingSubmission && !enableEditByCorrection) ||
        (isPosted && isViewOnly);

    return (
        <Grid2 item size={size || { xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].reimbursedAmount`}
                defaultValue={expense.reimbursedAmount !== null ? expense.reimbursedAmount : ''}
                rules={{
                    required: required.required ? 'Reimbursed amount is required' : false,
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        {...required}
                        placeholder=""
                        id={`expense-reimbursed-amount${index}`}
                        onChange={(e) => onChange(valueAsExpense(e.target.value))}
                        value={value}
                        label="Reimbursed amount"
                        endAdornment={<USDollarCurrencyInputAdornment disabled={isDisabled} />}
                        error={Boolean(errors.expenseEntries?.[index]?.reimbursedAmount)}
                        disabled={isDisabled}
                        helperText={errors.expenseEntries?.[index]?.reimbursedAmount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default ExpenseReimbursedAmount;
